module.exports = __webpack_public_path__ + "static/img/diodo_zener-1.ec443f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/diodo_zener-1.svg
// module id = 3ZUV
// module chunks = 0